<template>
    <div class="all_notes_box">
        <div v-if="notesData.length > 0">
            <pull2 :pull="pull" :page="page" @getList="getList">
                <div class="notes_item_box" v-for="(item, index) in notesData" :key="index">
                    <div class="user_info_box">
                        <!-- <img :src="item.customeratturl" alt=""> -->
                        <img :src="!item.customeratturl || item.customeratturl === ' ' ? require('@/common/images/header/user.png') : item.customeratturl" alt="">
                        <div>
                            <span>{{item.customername}}</span>
                        </div>
                    </div>
                    <p class="notes_text">{{item.content}}</p>
                    <div class="date_div">
                        <p>{{item.datetime}}</p>
                        <!-- <p><img :src="require('@/common/images/other/like.png')" alt="">赞({{item.praisecount}})</p> -->
                    </div>
                </div>
            </Pull2>
        </div>
        <div v-if="notesData.length === 0" class="no_data_box">
            <img :src="require('@/common/images/mobile/img-noData.png')" alt="">
            <p>当前课程暂无笔记</p>
        </div>
    </div>
</template>

<script>
import Pull2 from 'views/mobile/components/pull/pull2'
import {getAllCourseNotes} from 'api/api'
import { mapGetters, mapActions } from "vuex"
export default {
    name: 'allNotes',
    props: ['allNotesData'],
    data() {
        return {
            notesData: [],
            page: {
                page: 1,
                pagesize: 10,
                pageCount: 2,
                rowCount: 0
            },
            pull: {
                isLoading: false,
                loading: false,
                error: false,
                finished: false
            }
        }
    },
    mounted() {
        // setTimeout(() => {
        //     this.pageName = "asyncaaaaaaaaaaaaaaaaaaaaaa";
        // }, 2000)
    },
    methods: {
        // 获取全部笔记（公开的）
        findAllNotes(val) {
            this.setLoading(true)
            var params = {
                courseid: this.$route.query.cid,
                page: val,
                pagesize: 10
            }
            getAllCourseNotes({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.notesData = data.data.notesinfo
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        findMyPostAllNotes() {
            this.setLoading(true)
            var params = {
                courseid: this.$route.query.cid,
                page: 1,
                pagesize: 1
            }
            getAllCourseNotes({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    // this.notesData = data.data.notesinfo
                    var arry = data.data.notesinfo
                    var arry2 = this.notesData
                    arry = arry.concat(arry2)
                    this.notesData = arry
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        getList() {
            this.setLoading(true)
            var params = {
                courseid: this.$route.query.cid
            }
            getAllCourseNotes({
                data: Object.assign({}, params, this.page),
                success: data => {
                    if (this.page.page === 1) {
                        this.pull.isLoading = false
                        this.notesData = data.data.notesinfo
                    } else {
                        this.notesData = this.notesData.concat(data.data.notesinfo)
                    }
                    this.setLoading(false)
                    this.pull.loading = false
                    this.page.pageCount = data.data.pageinfo.pageCount
                    this.page.rowCount = data.data.pageinfo.rowCount
                    if (this.page.page === this.page.pageCount) {
                        this.pull.finished = true
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.pull.error = true
                    this.pull.loading = false
                    this.$toast.fail(data.msg)
                }
            })
        },
        // loadingaaaaa() {
        //     this.setLoading(true);
        //     setTimeout(() => {
        //         this.setLoading(false);
        //     }, 3000);
        // },
        // aaaaaaaaaaaaaaa() {
        //     this.$message.error("啊啊啊啊啊啊啊啊啊啊啊啊");
        //     // this.$router.push({ name: "Other" });
        // },
        ...mapActions(["setLoading"])
    },
    filters: {},
    watch: {
        allNotesData(newVal, oldVal) {
            if (JSON.stringify(newVal) === JSON.stringify(oldVal)) {
                return
            }
            this.$nextTick(() => {
                // console.log(this.allNotesData)
                this.notesData = this.allNotesData
            })
        }
    },
    computed: {
        ...mapGetters(["loading"])
    },
    components: {
        Pull2
    }
};
</script>

<style lang="scss" type="text/scss"></style>